module.exports = __webpack_public_path__ + "static/partners-845dfd087fd44dcde63b958d5dce09eb.svg";